var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartContracts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nft (4) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.9732 43.0659C57.1684 38.864 57.3512 30.416 52.0987 32.0974C49.7472 32.8501 47.0817 33.626 47.1526 30.5581C47.2661 25.649 51.535 21.5144 50.9504 16.0372C49.9037 6.2321 1.12298 -7.35965 10.0805 4.81598C25.3002 25.5039 1.47736 19.9985 10.522 35.865C13.2435 40.6392 8.25586 40.8245 8.25586 46.6096C8.25573 72.2962 55.8062 68.192 56.9732 43.0659Z",
    fill: "url(#paint0_linear_3927_177103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.3396 10.7168H24.643C23.9526 10.7168 23.393 11.2764 23.393 11.9668V14.9633H20.3965C19.7061 14.9633 19.1465 15.5229 19.1465 16.2133V44.5353C14.6592 44.5353 11.0215 48.173 11.0215 52.6603C11.0215 57.1477 14.6592 60.7853 19.1465 60.7853C22.6867 60.7853 25.6966 58.5203 26.81 55.3608H47.0931C47.7835 55.3608 48.3431 54.8012 48.3431 54.1108V51.1143H51.3396C52.03 51.1143 52.5896 50.5547 52.5896 49.8643V11.9668C52.5896 11.2764 52.0299 10.7168 51.3396 10.7168Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3719 34.4376C14.4891 34.5548 14.648 34.6207 14.8139 34.6207C14.9797 34.6207 15.1386 34.5548 15.2559 34.4376L16.1851 33.5082C16.4292 33.2642 16.4292 32.8685 16.1851 32.6243C15.9411 32.3805 15.5452 32.3803 15.3012 32.6245L14.814 33.1117L14.3267 32.6245C14.0827 32.3805 13.6871 32.3805 13.4429 32.6243C13.1987 32.8685 13.1987 33.2642 13.4429 33.5082L14.3719 34.4376Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.3267 31.5176L14.814 31.0304L15.3012 31.5175C15.4234 31.6396 15.5832 31.7006 15.7432 31.7006C15.9032 31.7006 16.0631 31.6396 16.1852 31.5175C16.4294 31.2735 16.4294 30.8778 16.1852 30.6338L15.256 29.7045C15.012 29.4605 14.6164 29.4605 14.3721 29.7044L13.4429 30.6336C13.1987 30.8777 13.1987 31.2735 13.4429 31.5175C13.6869 31.7616 14.0826 31.7616 14.3267 31.5176Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.8262 37.1309H15.7444C16.0895 37.1309 16.3694 36.8511 16.3694 36.5059C16.3694 36.1606 16.0895 35.8809 15.7444 35.8809H11.8262C11.481 35.8809 11.2012 36.1606 11.2012 36.5059C11.2012 36.8511 11.481 37.1309 11.8262 37.1309Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.07617 39.4668H15.7444C16.0895 39.4668 16.3694 39.187 16.3694 38.8418C16.3694 38.4965 16.0895 38.2168 15.7444 38.2168H9.07617C8.73105 38.2168 8.45117 38.4965 8.45117 38.8418C8.45117 39.187 8.73105 39.4668 9.07617 39.4668Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.3695 41.1777C16.3695 40.8325 16.0897 40.5527 15.7445 40.5527H9.07617C8.73105 40.5527 8.45117 40.8325 8.45117 41.1777C8.45117 41.523 8.73105 41.8027 9.07617 41.8027H15.7444C16.0897 41.8027 16.3695 41.523 16.3695 41.1777Z",
    fill: "#F67443"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.3391 48.1143H24.6426C23.9522 48.1143 23.3926 47.5547 23.3926 46.8643V8.9668C23.3926 8.27642 23.9522 7.7168 24.6426 7.7168H51.3392C52.0296 7.7168 52.5892 8.27642 52.5892 8.9668V46.8643C52.5891 47.5547 52.0295 48.1143 51.3391 48.1143Z",
    fill: "#FFC0A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.5891 14.1793V8.9668C52.5891 8.27642 52.0295 7.7168 51.3391 7.7168H24.6426C23.9522 7.7168 23.3926 8.27642 23.3926 8.9668V46.8643C23.3926 47.5547 23.9522 48.1143 24.6426 48.1143H51.3392C52.0296 48.1143 52.5892 47.5547 52.5892 46.8643V17.8908",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M47.0931 52.3604H20.3965C19.7061 52.3604 19.1465 51.8008 19.1465 51.1104V13.2129C19.1465 12.5225 19.7061 11.9629 20.3965 11.9629H47.0931C47.7835 11.9629 48.3431 12.5225 48.3431 13.2129V51.1104C48.3431 51.8008 47.7835 52.3604 47.0931 52.3604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M30.5237 52.3604H47.0931C47.7835 52.3604 48.3431 51.8008 48.3431 51.1104V13.2129C48.3431 12.5225 47.7835 11.9629 47.0931 11.9629H20.3965C19.7061 11.9629 19.1465 12.5225 19.1465 13.2129V51.1104",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M43.6176 15.9807L42.6079 17.807C42.4697 18.0568 42.6505 18.3635 42.936 18.3635H44.9554C45.241 18.3635 45.4217 18.057 45.2835 17.807L44.2737 15.9807C44.1312 15.7226 43.7602 15.7226 43.6176 15.9807Z",
    fill: "#FFC0A8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.2199 15.7871H26.9715C26.5466 15.7871 26.1541 16.0137 25.9416 16.3817L22.3175 22.659C22.1051 23.0269 22.1051 23.4802 22.3175 23.8481L25.9416 30.1254C26.154 30.4932 26.5466 30.72 26.9715 30.72H34.2199C34.6447 30.72 35.0372 30.4934 35.2497 30.1254L38.8739 23.8481C39.0862 23.4802 39.0862 23.0269 38.8739 22.659L35.2497 16.3817C35.0372 16.0137 34.6447 15.7871 34.2199 15.7871Z",
    fill: "#FFC0A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.5545 18.4219H29.9902V28.0831",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.8066 28.0851L25.0176 23.2545L27.8066 24.3712V18.4238",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M29.9902 23.0859H31.3422",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M33.5527 20.7285V28.0828",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M32.1543 20.6621H34.954L36.2278 22.9287",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M23.291 43.6191H44.1919",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M40.9629 46.166H44.1936",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M23.291 46.166H37.9879",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M23.291 37.0801H44.1919",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M31.1504 39.627H44.1905",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M23.291 39.627H28.1379",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M39.377 30.6953H44.1902",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M23.291 34.5312H44.1919",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M44.334 20.6641V23.1431",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M44.3418 25.3125H44.3562",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M44.3418 27.2051H44.3562",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M19.1465 57.7852C23.6338 57.7852 27.2715 54.1475 27.2715 49.6602C27.2715 45.1728 23.6338 41.5352 19.1465 41.5352C14.6592 41.5352 11.0215 45.1728 11.0215 49.6602C11.0215 54.1475 14.6592 57.7852 19.1465 57.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M19.1455 56.2245C22.7714 56.2245 25.7108 53.2851 25.7108 49.6591C25.7108 46.0332 22.7714 43.0938 19.1455 43.0938C15.5195 43.0938 12.5801 46.0332 12.5801 49.6591C12.5801 53.2851 15.5195 56.2245 19.1455 56.2245Z",
    fill: "#FFC0A8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M19.9216 48.6472L19.1516 53.9772H19.1454C19.0904 53.9772 19.0366 53.9647 18.9866 53.9409L15.3979 52.2622C15.2666 52.2009 15.1816 52.0684 15.1816 51.9222V47.3959C15.1816 47.3172 15.2066 47.2422 15.2516 47.1797L19.9216 48.6472Z",
    fill: "#F67443"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M23.1102 47.3956V51.9219C23.1102 52.0681 23.0252 52.2006 22.894 52.2619L19.3052 53.9406C19.2552 53.9644 19.2015 53.9769 19.1465 53.9769V47.9744L23.0352 47.1719C23.0827 47.2356 23.1102 47.3131 23.1102 47.3956Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M23.0441 47.1874L19.1441 49.0112L15.2441 47.1874C15.2816 47.1312 15.3341 47.0862 15.3966 47.0562L18.9854 45.3774C19.0854 45.3299 19.2029 45.3299 19.3029 45.3774L22.8916 47.0562C22.9541 47.0862 23.0066 47.1312 23.0441 47.1874Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M19.1465 57.7852C23.6338 57.7852 27.2715 54.1475 27.2715 49.6602C27.2715 45.1728 23.6338 41.5352 19.1465 41.5352C14.6592 41.5352 11.0215 45.1728 11.0215 49.6602C11.0215 54.1475 14.6592 57.7852 19.1465 57.7852Z",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M13.8848 30.0664L14.814 30.9957L15.7433 30.0664",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M15.7433 28.0757L14.814 27.1465L13.8848 28.0757",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.7445 33.5059H11.8262",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.7445 35.8418H9.07617",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M15.7445 38.1777H9.07617",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M9.31049 27.3105L7.87305 25.873L6.4356 27.3105L7.87305 28.7479L9.31049 27.3105Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M56.6621 5.05268L55.2246 3.61523L53.7872 5.05268L55.2246 6.49013L56.6621 5.05268Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M30.3027 57.6172C30.9586 57.6172 31.4902 57.0855 31.4902 56.4297C31.4902 55.7738 30.9586 55.2422 30.3027 55.2422C29.6469 55.2422 29.1152 55.7738 29.1152 56.4297C29.1152 57.0855 29.6469 57.6172 30.3027 57.6172Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M57.0449 13.1504C57.7008 13.1504 58.2324 12.6187 58.2324 11.9629C58.2324 11.3071 57.7008 10.7754 57.0449 10.7754C56.3891 10.7754 55.8574 11.3071 55.8574 11.9629C55.8574 12.6187 56.3891 13.1504 57.0449 13.1504Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M14.0098 22.1523C14.6656 22.1523 15.1973 21.6207 15.1973 20.9648C15.1973 20.309 14.6656 19.7773 14.0098 19.7773C13.3539 19.7773 12.8223 20.309 12.8223 20.9648C12.8223 21.6207 13.3539 22.1523 14.0098 22.1523Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_177103",
    x1: 6.7302,
    y1: 52.0538,
    x2: 47.5466,
    y2: 11.2374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC0A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContracts);
export default __webpack_public_path__ + "static/media/smartContracts.c1c929d28cf1862a760359e252ac4d26.svg";
export { ForwardRef as ReactComponent };